import React from 'react';
import { Box, Button, Chip, Modal, Typography, Link } from '@material-ui/core';

// The "value" is the data you pass on getRenderer
const KVSLinks = ({ open = false, onClose = () => {}, value = '' }) => {
  function openURL(url) {
    if (!url.includes('http')) url = 'https://' + url;

    window.open(url, '_blank');
  }

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            padding: '1rem',
            width: '80%',
            maxWidth: '400px',
            borderRadius: '12px',
            marginBottom: '2rem',
            position: 'relative' // For positioning close button
          }}
        >
          <Typography
            variant="h6"
            style={{
              marginBottom: '1rem',
              alignSelf: 'flex-start' // Aligns "Links" to the left
            }}
          >
            Links
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            style={{ gap: '1rem', width: '100%' }}
          >
            {value?.length ? (
              value.map(item => (
                <Chip
                  clickable
                  variant="outlined"
                  color="primary"
                  label={item.label}
                  icon={<Link fontSize="small" />}
                  size="small"
                  key={item.url}
                  onClick={() => openURL(item.url)}
                  style={{
                    width: '100%',
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                    paddingLeft: '8px'
                  }}
                />
              ))
            ) : (
              <Typography>No links added</Typography>
            )}
          </Box>
          <Box
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={onClose}
              style={{ marginTop: '2rem' }}
              size="small"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default React.memo(KVSLinks);
